import translation from 'translation';
import {BIDDABLE_TYPES as B_TYPES} from 'store/modules/bidmanager/utils/common';


export const BIDDABLE_TYPES = [
  {
    ...B_TYPES.KEYWORD,
    id: 'KEYWORD',
    name: () => translation.trc('ozon_instrumental', 'Keyword'),
    description: () => translation.trc('ozon_biddable_description', 'Changing bids for keywords')
  },
  {
    id: 'AD',
    name: () => translation.trc('ozon_instrumental', 'Products'),
    description: () => translation.trc('ozon_biddable_description', 'Changing bids for products')
  }
];
